// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file

import { format } from "jquery";

import { DateFieldValidation } from "./DateFieldValidation";

export class CustomQuestionManager {
    public static Init() {

        $(".survey_popup_ctrl").each(function (index) {
            CustomQuestionManager.SetSurveyRequiredFieldHelpText($(this));
        });
        CustomQuestionManager.SetPhoneMask();

        //@* Enable bootstrap tooltips * @
        $('[data-bs-toggle="tooltip"]').each(function () {
            $(this).tooltip({ placement: "right", html: true });
        });

        $(".icf-custom-date").datepicker();

        $(".icf-custom-date-icon").on("click", function (e) {
            var inpt = $(this).closest(".input-group").find("input");
            if (!inpt.is(":disabled")) {
                $(this).closest(".input-group").find("input").focus();
            }
        });

        $(".icf-radiolist-opt").on("click", (event: JQuery.TriggeredEvent) => {
            var id = $(event.currentTarget).val();
            $(event.currentTarget).closest('.icf-radiolist').find('input[type=text]').val('').prop('readonly', true);
        })

        $(".icf-radiolist-other-opt").on("click", (event: JQuery.TriggeredEvent) => {
            var id = $(event.currentTarget).val();
            $(event.currentTarget).closest('.icf-radiolist').find('input[type=text]').prop('readonly', false);
        })

        $(".icf-checkboxlist-other-opt").on("click", (event: JQuery.TriggeredEvent) => {
            CustomQuestionManager.ToggleOtherTextbox(event.currentTarget);
        })

        //Check for readonly model.
        var editCode = $("#EditMode").val() as string;
        if (editCode === "Status") {
            $('#custom-question-div :input').prop('readonly', true).prop('disabled', true);
        }

        //Unhide fieldset/accordion
        $(".custom-question-div").each(function () {  
           if ($(this).find("input").length > 0) {  
               $(this).closest(".equipment-attr-fs").removeClass("d-none");  
           }  
        });

    }

    static SetCustomDateRanges() {

        $(".icf-custom-date").each((index, element) => {

            var minValue = $(element).data("icf-min-date");
            var maxValue = $(element).data("icf-max-date");
            var maxDate: Date = (maxValue != null) ? new Date(maxValue) : null;
            var minDate: Date = (minValue != null) ? new Date(minValue) : null;

            var minRange = $(element).data("icf-min-date-range");
            var maxRange = $(element).data("icf-max-date-range");

            var requiredFld = <FormFieldModel>{
                DateMinValue: minDate, HasDateMinValue: (minValue != null && minValue !== ""), DateMaxValue: maxDate, HasDateMaxValue: (maxValue != null && maxValue !== ""),
                MinValue: (minRange != null) ? parseInt(minRange) : null, MaxValue: (maxRange != null) ? parseInt(maxRange) : null,
                HasMinValue: (minRange != null && minRange !== ""), HasMaxValue: (maxRange != null && maxRange !== "")
            };

            DateFieldValidation.SetDateFieldValidation(requiredFld, $(element).attr("id"));
        });
    }


    private static ClearDateField(dateText, dateInstance) {
        $("#" + dateInstance.id).removeClass('input-validation-error').addClass('valid');
        $("#" + dateInstance.id).closest(".equipment-attr").children(".field-validation-error").removeClass('field-validation-error').addClass('field-validation-valid').empty();
    }

    private static SetPhoneMask() {
        (<any>$(".phone-Mask")).mask("(000) 000-0000", { clearIfNotMatch: true });
    }

    private static SetSurveyRequiredFieldHelpText(helpNode) {

        var helpImageUrl;
        if ($("#icf-common-help-url").length) {
            helpImageUrl = $("#icf-common-help-url").val();
        }

        if (typeof helpImageUrl !== "undefined") {
            var popoverCtrl = helpNode.siblings(".popover-link").first();
            popoverCtrl.html(helpImageUrl);
            popoverCtrl.popover({
                placement: 'bottom',
                container: 'body',
                html: true,
                //title: '<span class="text-info"><strong>' + field.ContextHelpTitle + '</strong></span>' +
                //'<button type="button" id="close" class="close" onclick="$(&quot;#' + popId + '&quot;).popover(&quot;hide&quot;);">&times;</button>',
                content: helpNode.val()
            });
        }
    }

    private static ToggleOtherTextbox(theField) {

        var element = $("#" + theField.id).closest('.icf-checkbox-list').find('input[type=text]').first();
        var isReadonly = $(element).prop('readonly');
        if (isReadonly) {
            $(element).prop('readonly', false);
        } else {
            $(element).prop('readonly', true).val('');
        }
    }

}

